import type { CSSProperties, FC } from "react";

import {Box, Text, useMediaQuery} from "@chakra-ui/react";

import type { DragSourceMonitor } from "react-dnd";
import { useDrag } from "react-dnd";
import { FaEraser } from "react-icons/fa";
import { ERASER_LABEL } from "../constants";

interface DraggableNumberBoxProps {
  label?: string;
  droppableId?: string;
  onDropEnd?: (label: string, targetBoxName: string, regroupingMode: boolean) => void;
  isDisabled?: boolean;
  regroupingMode?: boolean;
}

export const ItemTypes = {
  BOX: "box",
};

interface DropResult {
  allowedDropEffect: string;
  dropEffect: string;
  name: string;
}

const style: CSSProperties = {
  border: "1px dashed gray",
  backgroundColor: "white",
  padding: "0.5rem 1rem",
  marginRight: "1.5rem",
  marginBottom: "1.5rem",
  float: "left",
};

export default function DraggableNumberBox(props: DraggableNumberBoxProps) {
  const { label, onDropEnd, isDisabled = false, regroupingMode } = props;
  const [isLargeScreen] = useMediaQuery("(min-width: 764px)");

  const [{ opacity }, drag] = useDrag(
    () => ({
      type: ItemTypes.BOX,
      item: {
        label: label,
      },
      end(item, monitor) {
        const dropResult = monitor.getDropResult() as DropResult;

        if (item && dropResult) {
          let alertMessage = "";
          const isDropAllowed =
            dropResult.allowedDropEffect === dropResult.dropEffect;

          if (isDropAllowed || true) {
            const isCopyAction = dropResult.dropEffect === "copy";
            const actionName = isCopyAction ? "copied" : "moved";

            onDropEnd?.(item.label as string, dropResult.name, regroupingMode as boolean);
          } else {
          }

          //TODO last here
        }
      },
      collect: (monitor: DragSourceMonitor) => ({
        opacity: monitor.isDragging() ? 0.4 : 1,
      }),
      canDrag: () => !isDisabled,
    }),
    [label, onDropEnd, regroupingMode]
  );

  return (
    <Box
      ref={drag}
      sx={{
        width: isLargeScreen ? "50px" : "48px",
        height: isLargeScreen ? "50px" : "48px",
        border: `1px solid ${regroupingMode ? "#B6DEB0" : "#E7E1D8"}`,
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: regroupingMode ? "#94DAF3" : "#fff",
        mx: isLargeScreen ? 0 : '3px!important',
        my: isLargeScreen ? 0 : '3px!important',
        fontSize: isLargeScreen ? "1.26rem" : "1rem",
        opacity,
      }}
    >
      {label === ERASER_LABEL ? <FaEraser /> : label === "↑" ? "+1" : label}
    </Box>
  );

  // return (
  //   <Droppable droppableId="droppableId" isCombineEnabled>
  //     {(provided) => (
  //       <Box
  //         sx={{
  //           width: "40px",
  //           height: "40px",
  //           border: "1px solid #E7E1D8",
  //           borderRadius: "12px",
  //           display: "flex",
  //           alignItems: "center",
  //           justifyContent: "center",
  //         }}
  //         ref={provided.innerRef}
  //         {...provided.droppableProps}
  //       >
  //         <Text fontWeight={900}>{label}</Text>
  //       </Box>
  //     )}
  //   </Droppable>
  // );
}
